import { render } from "./SetoresView.vue?vue&type=template&id=752f5b2c&scoped=true"
import script from "./SetoresView.vue?vue&type=script&lang=js"
export * from "./SetoresView.vue?vue&type=script&lang=js"

import "./SetoresView.vue?vue&type=style&index=0&id=752f5b2c&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/plantoes-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752f5b2c"]])

export default __exports__